/* @flow */

import { gql } from 'apollo-boost';

// eslint-disable-next-line import/prefer-default-export
export const LOGIN = gql`
mutation Login($password: String!, $email: String!) {
    login(input: {
      email: $email,
      password: $password
    }) {
      user {
        apiKey
      }
    }
  }
`;

export const LOJAS = gql`query { allShops { edges { node { name pk } } } }`;

export const ESTIMATE_CREATE_ORDER = gql`
query EstimateCreateOrder(
  $shopId: Int!
  $pickups: [Pickup]!
  $packages: [Packages]!
) {
  estimateCreateOrder(
    shopId: $shopId
    pickups: $pickups
    packages: $packages
)  {
    totalEstimate{
      totalCost
      totalEta
    }
  }
}
`;

export const CREATE_ORDER = gql`
mutation CreateOrder(
  $shopId: Int!
  $pickups: [Pickup]!
  $packages: [Packages]!
) {
  createOrder(input: {
    shopId: $shopId
    pickups: $pickups
    packages: $packages
  }) {
    success
    orders {
      pk
    }
    errors {
      field
      message
    }
  }
}
`;
